import { createApiClient } from "@alfabetizando/contracts";

export function resolveApiBaseUrl(configuredValue: unknown): string {
  if (typeof configuredValue !== "string") {
    return "/api";
  }

  return configuredValue.trim() || "/api";
}

type ApiClient = ReturnType<typeof createApiClient>;

let configuredApiClient: ApiClient | undefined;

function getConfiguredApiClient(): ApiClient {
  return (configuredApiClient ??= createApiClient({
    baseUrl: resolveApiBaseUrl(import.meta.env.VITE_API_BASE_URL),
  }));
}

export const apiClient: ApiClient = new Proxy({} as ApiClient, {
  get(_target, property) {
    const client = getConfiguredApiClient() as unknown as Record<PropertyKey, unknown>;
    return client[property];
  },
});
